import styled from "@emotion/styled";
import XIcon from "../../../img/x.svg?react";
import GuildIcon from "../../../img/guild.svg?react";
import MediumIcon from "../../../img/medium.svg?react";
import DiscordIcon from "../../../img/discord.svg?react";
import { Text } from "components/general/Text";
import { useHover } from "usehooks-ts";
import { useRef } from "react";
import { BEBOP_ROUTES, NAV_LINKS } from "config/consts";
import { Button, ButtonBorderRadius } from "components/general/Button/Button";
import { css } from "@emotion/react";
import { MOBILE_WIDTH, useIsMobile } from "hooks/useDeviceType";
import { Title } from "./element/Title";
import { Link } from "react-router-dom";

export const Cta = () => {
  const marqueeRef = useRef<HTMLDivElement>(null);
  const isMarqueeHovered = useHover(marqueeRef);
  const isMobile = useIsMobile();
  const iconSize = isMobile ? 18 : 32;

  const links = MARQUEE_CONTENT.map(entry => {
    const Icon = entry.icon;
    return (
      <Link
        key={entry.text}
        to={entry.link}
        target="_blank"
        rel="noreferrer nofollow"
        style={{
          display: "flex",
          gap: 9,
          alignItems: "center",
          float: "left",
        }}
      >
        <Icon width={iconSize} height={iconSize} />
        <Text textStyle="Title" size="Large" shouldScale={true}>
          {entry.text}
        </Text>
      </Link>
    );
  });

  return (
    <div style={{ width: "100%" }}>
      <Marquee ref={marqueeRef}>
        <MarqueeContent isHover={isMarqueeHovered}>{links}</MarqueeContent>
        <MarqueeContent isHover={isMarqueeHovered}>{links}</MarqueeContent>
      </Marquee>
      <Container>
        <Title>Make your move</Title>
        <Button
          buttonType="primary"
          navigateTo={BEBOP_ROUTES.Trade}
          data-testid="start-trading-btn"
          buttonCss={css`
            padding: 22px;
            justify-content: center;
            align-items: center;
            border-radius: ${ButtonBorderRadius.Mid};
            width: fit-content;

            @media (max-width: ${MOBILE_WIDTH}px) {
              padding: 11px 14px;
            }
          `}
        >
          <Text textStyle="Title" size="Large" shouldScale={true}>
            Start trading
          </Text>
        </Button>
      </Container>
    </div>
  );
};

// Sub-components

const Container = styled.div(() => ({
  padding: "160px 100px",
  display: "flex",
  flexDirection: "column",
  gap: 36,
  justifyContent: "center",
  alignItems: "center",

  [`@media (max-width: ${MOBILE_WIDTH}px)`]: {
    padding: "56px 50px",
  },
}));

const Marquee = styled.div(({ theme }) => ({
  position: "relative",
  overflow: "hidden",
  display: "flex",
  backgroundColor: theme["Brand colours"].Yellow,
  color: theme.button.secondary.text.default,
  padding: "20px 0",
  userSelect: "none",
  gap: GAP_WIDTH,

  "&:hover": {
    color: theme.button.secondary.text.hover,
  },
}));

const MarqueeContent = styled.div<{ isHover: boolean }>(({ isHover }) => ({
  flexShrink: 0,
  display: "flex",
  justifyContent: "space-around",
  minWidth: "100%",
  whiteSpace: "nowrap",
  animation: "marquee 10s linear infinite",
  animationPlayState: isHover ? "paused" : "running",
  gap: GAP_WIDTH,
  "@keyframes marquee": {
    from: { transform: "translateX(0)" },
    to: { transform: `translateX(calc(-100% - ${GAP_WIDTH}px))` },
  },

  "@media (prefers-reduced-motion: reduce)": {
    animationPlayState: "paused !important",
  },
}));

// Helpers

const GAP_WIDTH = 40;

const MARQUEE_CONTENT = [
  { icon: XIcon, text: "Follow on X", link: NAV_LINKS.TWITTER },
  { icon: GuildIcon, text: "Get perks on Guild", link: NAV_LINKS.GUILD },
  { icon: MediumIcon, text: "Learn on Medium", link: NAV_LINKS.MEDIUM },
  { icon: DiscordIcon, text: "Join us on Discord", link: NAV_LINKS.DISCORD },
];
